module.exports = __webpack_public_path__ + "static/media/ac4.4c438f7d.jpg";